import { ChipProps } from "@mui/material";

export const getInvoiceChipColor = (status: string): ChipProps["color"] => {
  switch (status) {
    case "open":
      return "warning";
    case "paid":
      return "success";
    default:
      return "secondary";
  }
};

export const formatInvoiceDate = (timestamp: number): string => {
  return new Date(timestamp * 1000).toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const formatInvoiceAmount = (total: number): string => {
  return `$${(total / 100).toFixed(2)}`;
};

